<template>
    <v-flex xs12 sm12 md12 lg12 xl9 class="content">
        <slot v-if="appLoaded"></slot>
    </v-flex>
</template>

<script>
    export default {
        name: "MainContentWrapperBig",
        methods: {
            appLoaded(){
                return this.$store.state.application.loaded;
            }
        }
    }
</script>

<style scoped>

</style>